import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SpartaxUserRole, SpartaxUserUtil } from 'src/app/data/dto/spartax/spartax-user.dto';
import { SpartaxUtils } from 'src/app/utils/spartax-utils';

@Component({
  selector: 'app-spartax-order-success-dialog',
  templateUrl: './spartax-order-success-dialog.component.html',
  styleUrls: ['./spartax-order-success-dialog.component.scss'],
})
export class SpartaxOrderSuccessDialogComponent implements OnInit {
  orderDisplayName: string;
  orderCreationStatus: string;
  formId: string;
  orderListItemId: number;
  currentUserRole: SpartaxUserRole;

  constructor(private modalController: ModalController,) { }

  ngOnInit() {}

  closeModal() {
    this.modalController.dismiss();
  }

  startNewQuestionnaire() {
    window.location.href = `/forms/fillout/${this.formId}?edit=true`;
  }

  viewOrder() {
    SpartaxUtils.openOrder(this.orderListItemId, '_self');
  }

  canViewOrder() {
    return SpartaxUserUtil.hasMinimumRole(SpartaxUserRole.Sachbearbeiter, this.currentUserRole);
  }
}
